<template>
  <fragment>
    <div>
    </div>
    <nav class="navbar-wrapper navbar--mobile">
      <div class="navbar d-md-none">
        <div class="d-inline">
          <ValidationObserver ref="userForm" slim>
            <div class="row d-inline-flex d-flex justify-content-start align-items-center">
              <a href="" class="d-lg-none burger-button hamburger ml-2"
                 @click.prevent="mobileShown = !mobileShown" :class="{ collapsed: mobileShown }">
                <svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="25" height="2" fill="currentColor"/>
                  <rect y="7" width="25" height="2" fill="currentColor"/>
                  <rect y="14" width="25" height="2" fill="currentColor"/>
                </svg>
              </a>
              <router-link class=" p-0" :to="{ name:'' }">
                <svg class="logo" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.8421 6.79683C23.0149 6.07761 21.6484 4.92685 20.4257 3.84801C19.9223 3.38051 19.4548 3.12878 18.9513 3.12878C17.9804 3.12878 16.9375 3.95589 16.1104 4.71108C17.4769 5.8978 20.2459 8.27125 21.6125 9.45797C22.5115 10.2132 22.5834 10.7885 22.5834 11.4358V17.5133C22.5834 18.9517 21.3967 20.1385 19.9582 20.1385H10.3206C8.88217 20.1385 7.69545 18.9517 7.69545 17.5133V12.8743C7.19199 13.2699 6.54469 13.5216 5.82546 13.5216C5.25008 13.5216 4.71066 13.3418 4.24316 13.0901V17.4773C4.24316 20.8217 6.97622 23.5548 10.3206 23.5548H19.9223C23.2667 23.5548 25.9997 20.8217 25.9997 17.4773V11.3999C25.9997 10.1053 25.748 8.41509 23.8421 6.79683Z"
                        class="shape"/>
                  <path d="M13.4495 4.53112C13.5214 4.4592 13.6293 4.35131 13.7732 4.20747C14.5643 3.38036 15.8949 1.97787 17.4772 1.43845C17.3333 1.29461 17.2254 1.15076 17.0816 1.00692L16.9737 0.934993C16.3624 0.395574 15.6072 0 14.5643 0C13.1259 0 12.4066 0.683264 11.5436 1.5823L5.71784 7.51591C5.60996 7.40802 5.46611 7.30014 5.35823 7.19225C5.28631 7.12033 5.21438 7.04841 5.14246 7.01245C5.1065 6.97649 5.07054 6.94053 5.03458 6.90456C3.59613 5.71784 1.7621 5.60996 0 7.30014C1.33057 8.23513 3.12863 9.78147 4.56708 11.184C4.89073 11.5076 5.32227 11.6874 5.78976 11.6874C6.25726 11.6874 6.6888 11.5076 7.01245 11.184L13.4495 4.53112Z"
                        fill="#F7981C"/>
                </svg>
              </router-link>
              <!-- <ValidatedField
                type="text"
                id="search"
                name="search"
                class="mb-0 ml-2"
                placeholder="Search"
                no-tooltip
                input-class="form-control-sm"
                no-icon
                no-validate
                v-model="search"
                rules="required|min:3"
              />
              <a class="p-0 m-0 cursor-pointer"
                 @click.prevent="onSearch">
                <icon width="14" height="14" type="search" class="ml-4"/>
              </a> -->
            </div>
          </ValidationObserver>
        </div>
        <div class="d-inline">
          <b-dropdown v-if="asLoggedIn" size="sm" toggle-tag="div"
                      toggle-class="navbar-id-dropdown profile-menu" menu-class="w-100"
                      variant="link" boundary="viewport" class="profile-menu--mobile" no-caret>

          </b-dropdown>

          <b-dropdown v-if="asLoggedIn" size="sm" toggle-tag="div"
                      toggle-class="profile-menu" variant="link"
                      no-caret boundary="viewport" class="profile-menu--mobile" menu-class="w-100"
                      @hidden="collapseProfile">
            <template #button-content>
              <icon width="14" height="14" type="user" class="ml-4"/>
            </template>

            <b-dropdown-text class="text-nowrap text-center email">
              <b-avatar size="1.25rem"></b-avatar>
              <span class="email">{{ user.email }}</span>
            </b-dropdown-text>
            <b-dropdown-text class="text-nowrap text-center">
              <span class="user">{{ userName }}</span>
            </b-dropdown-text>

            <b-dropdown-divider/>

            <b-dropdown-item @click.prevent="logout">
              <div class="profile-menu-item">
                <div class="profile-menu-icon">
                  <icon width="14" height="14" type="sign-out" class="mr-1"/>
                </div>
                <span>{{ $t('menu.logout') }}</span>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </nav>

    <div class="d-flex main-container" :class="{ 'mobile-shown': mobileShown }">
      <div class="sidenav"
           :style="currentBackground"
           :class="{'d-md-block': sidebar, 'closed': collapsed && !hovered && !mobileShown }"
           @mouseenter="hovered = true"
           @mouseleave="hovered = false"
      >
        <nav
          class="sidenav-header d-none d-md-flex align-items-center"
        >
          <router-link class="p-0 mx-auto ml-sm-0" :to="{ name:'' }">
            <img v-if="asLoggedIn && currentLogo != null"
                 class="logo" :src="currentLogo" alt="logo">
            <svg v-else class="logo" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.8421 6.79683C23.0149 6.07761 21.6484 4.92685 20.4257 3.84801C19.9223 3.38051 19.4548 3.12878 18.9513 3.12878C17.9804 3.12878 16.9375 3.95589 16.1104 4.71108C17.4769 5.8978 20.2459 8.27125 21.6125 9.45797C22.5115 10.2132 22.5834 10.7885 22.5834 11.4358V17.5133C22.5834 18.9517 21.3967 20.1385 19.9582 20.1385H10.3206C8.88217 20.1385 7.69545 18.9517 7.69545 17.5133V12.8743C7.19199 13.2699 6.54469 13.5216 5.82546 13.5216C5.25008 13.5216 4.71066 13.3418 4.24316 13.0901V17.4773C4.24316 20.8217 6.97622 23.5548 10.3206 23.5548H19.9223C23.2667 23.5548 25.9997 20.8217 25.9997 17.4773V11.3999C25.9997 10.1053 25.748 8.41509 23.8421 6.79683Z"
                    class="shape"/>
              <path d="M13.4495 4.53112C13.5214 4.4592 13.6293 4.35131 13.7732 4.20747C14.5643 3.38036 15.8949 1.97787 17.4772 1.43845C17.3333 1.29461 17.2254 1.15076 17.0816 1.00692L16.9737 0.934993C16.3624 0.395574 15.6072 0 14.5643 0C13.1259 0 12.4066 0.683264 11.5436 1.5823L5.71784 7.51591C5.60996 7.40802 5.46611 7.30014 5.35823 7.19225C5.28631 7.12033 5.21438 7.04841 5.14246 7.01245C5.1065 6.97649 5.07054 6.94053 5.03458 6.90456C3.59613 5.71784 1.7621 5.60996 0 7.30014C1.33057 8.23513 3.12863 9.78147 4.56708 11.184C4.89073 11.5076 5.32227 11.6874 5.78976 11.6874C6.25726 11.6874 6.6888 11.5076 7.01245 11.184L13.4495 4.53112Z"
                    fill="#F7981C"/>
            </svg>
          </router-link>
          <a href="" v-if="asLoggedIn" @click.prevent="collapsed = !collapsed; hovered = false"
             class="burger-button" :class="{ collapsed }">
            <svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="25" height="2" fill="currentColor"/>
              <rect y="7" width="25" height="2" fill="currentColor"/>
              <rect y="14" width="25" height="2" fill="currentColor"/>
            </svg>
          </a>
        </nav>
        <side-nav
          :colorText="color_font"
        />
      </div>

      <div class="content"
           :class="{ 'no-navbar': !sidebar, 'bg-light': asLoggedIn, 'logged-in': asLoggedIn, 'nosidebar': collapsed }">
        <!-- @scroll="handleScroll" -->
        <portal-target name="modals"/>
        <div class="content-header d-none d-md-flex align-items-center justify-content-end"
             v-if="asLoggedIn">
          <div class="lang-switcher">
          </div>
          <!-- <div class="header-search d-inline">
            <ValidationObserver ref="userForm" slim>
              <div class="row d-inline-flex d-flex justify-content-start align-items-center">
                <div class="col d-inline-flex">
                  <ValidatedField
                    ref="searchInput"
                    type="text"
                    id="search"
                    name="search"
                    class="mb-0 search-width"
                    placeholder="Search translation"
                    no-tooltip
                    no-icon
                    no-validate
                    v-model="search"
                    autocomplete="off"
                    rules="required|min:3"
                    @keyup="handleKeyUp"
                  />

                  <div ref="searchResultsContainer"
                       :class="hideResults ? 'hide-search-results' : 'search-results-spinner'"
                       v-if="search !== '' && search.length > 0">
                    <div v-if="!loaded" class="lessResults">
                      <spinner />
                    </div>
                    <div v-else-if="loaded && typesenseData.length > 0">
                      <ul class="results-list">
                        <div v-for="result in typesenseData" :key="result.id">
                          <li class="result-item" @click=projectTranslationsUrl(result)>
                            {{
                              result.keywordId + ' ' +
                                result.languageIso + ' | ' +
                                result.pageName + ' > ' +
                                result.translation
                            }}
                          </li>
                        </div>
                      </ul>
                    </div>
                    <div v-else-if="typesenseData.length === 0" class="lessResults">
                      {{  "No results found" }}
                    </div>
                  </div>
                  <div class="col d-inline-flex">
                    <button class="btn btn-primary"
                            :disabled="($refs.userForm && !$refs.userForm.flags.valid) || disableSearchButton ||
                              (user.language === null && !isAdmin)"
                            @click.prevent="onSearch">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </ValidationObserver>
          </div> -->
          <div class="profile">
            <b-dropdown size="sm" toggle-tag="div" toggle-class="profile-menu navbar-settings-dropdown" variant="link"
                        no-caret right menu-class="mt-3 profile-dropdown" @hidden="collapseProfile">
              <template #button-content>
                <icon width="14" height="14" type="user" class="ml-4"/>
                <icon class="ml-2" stroke-width="2" width="12" height="7" type="arrow-down"/>
              </template>
              <b-dropdown-text class="text-nowrap text-center email">
                <b-avatar class="mr-2" size="1.25rem"></b-avatar>
                <span class="email">{{ user.email }}</span>
              </b-dropdown-text>
              <b-dropdown-text class="text-nowrap text-center">
                <span class="user">{{ userName }}</span>
              </b-dropdown-text>

              <b-dropdown-group v-b-toggle.billing-collapse class="accordion-items" v-if="pageAllowed('invoices')">
                <div class="accordion-collapse-btn">
                  <icon width="6" height="13" type="arrow-right" class="accordion-arrow"/>
                  <div class="profile-menu-item">
                    <div class="profile-menu-icon">
                      <icon width="12" height="18" type="legal-profile" class="mb-1 mr-2"/>
                    </div>
                    <span class="accordion-item">{{ $t('menu.billing') }}</span>
                  </div>
                </div>
              </b-dropdown-group>

              <b-dropdown-item :to="{ name: 'profile' }" v-if="userPageAllowed('profile')">
                <div class="profile-menu-item">
                  <div class="profile-menu-icon">
                    <icon width="14" height="18" type="user" class="mb-1 mr-1"/>
                  </div>
                  <span>{{ $t('menu.profile') }}</span>
                </div>
              </b-dropdown-item>

              <b-dropdown-group v-b-toggle.legal-collapse-desktop class="accordion-items" v-if="pageAllowed('legal')">
                <div class="accordion-collapse-btn">
                  <icon width="6" height="13" type="arrow-right" class="accordion-arrow"/>
                  <div class="profile-menu-item">
                    <div class="profile-menu-icon">
                      <icon width="12" height="18" type="legal-profile" class="mb-1 mr-2"/>
                    </div>
                    <span class="accordion-item">{{ $t('menu.legal') }}</span>
                  </div>
                </div>
                <b-collapse id="legal-collapse-desktop" class="accordion-sub-items">
                  <b-dropdown-item
                    class="subitem"
                    v-for="{ slug, title } in legalPagesList" :key="`page-${slug}`"
                    :to="{ name: 'legal', params: { page: slug }}"
                  >
                    {{ title }}
                  </b-dropdown-item>
                </b-collapse>
              </b-dropdown-group>

              <b-dropdown-divider/>

              <b-dropdown-item @click.prevent="logout">
                <div class="profile-menu-item">
                  <div class="profile-menu-icon">
                    <icon width="14" height="14" type="sign-out" class="mr-1"/>
                  </div>
                  <span>{{ $t('menu.logout') }}</span>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <main
          :class="mainClass" @click="closeMobileMenu">
          <router-view/>
          <b-modal
            id="expiredModal"
            ref="expiredModal"
            modal-class="session-expired-modal"
            no-fade
            static
            centered
            hide-header
            size="sm"
            :ok-title="$t('auth.expired.button')"
            ok-variant="danger"
            ok-only
            no-close-on-backdrop
            no-close-on-esc
            hide-header-close
            @ok.prevent="reload"
            :title="$t('auth.expired.title')"
          >
            <h5 class="text-danger">{{ $t('auth.expired.head') }}</h5>
            <p>{{ $t('auth.expired.text') }}</p>
          </b-modal>
        </main>
      </div>
    </div>
  </fragment>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import SideNav from '@/components/SideNav.vue';
  import { locales } from '@/shared';
  import { Storage, USER_KEY, LANG_KEY } from '@/services/storage.service';

  export default {
    name: 'App',
    components: { SideNav },
    data() {
      return {
        collapsed: false,
        hovered: false,
        mobileShown: false,
        logoMenu: null,
        hotelsFilter: '',
        showOverlay: true,
        color_schema: {
          r: 74,
          g: 143,
          b: 221,
        },
        color_font: {
          r: 255,
          g: 255,
          b: 255,
        },
        showChat: process.env.VUE_APP_ZAMMAD_CHAT_ENABLED === 'true',
        search: '',
        // lastSearch: '',
        // debounceTimeout: null,
        // hideResults: false,
        // lastQuery: '',
        // disableSearchButton: false,
        // currentPage: 1,
        // inputFocused: false,
      };
    },
    // created() {
    //   document.addEventListener('click', this.handleClickOutside);
    // },
    // beforeDestroy() {
    //   document.removeEventListener('click', this.handleClickOutside);
    // },
    computed: {
      ...mapGetters(['pageTitle', 'sidebar', 'centered', 'stretch']),
      ...mapGetters('user', [
        'user', 'loggedIn', 'sessionExpired', 'lang',
        'currentLogo', 'currentColorSchema', 'pageAllowed', 'userPageAllowed', 'isAdmin', 'isDeveloper', 'isTranslator',
      ]),
      // ...mapGetters('typesense', ['loaded', 'typesenseSearchResults']),
      // ...mapGetters('projectTranslations', ['activeProject', 'activeLanguage']),
      // ...mapGetters('search', ['totalKeywords', 'readyLoadMoreKeywords']),
      // typesenseData() {
      //   return this.typesenseSearchResults ?? [];
      // },
      asLoggedIn() {
        return this.loggedIn && !this.centered;
      },
      mainClass() {
        return this.asLoggedIn && !this.stretch
          ? `logged-in ${this.mobileShown ? 'mobile-shown' : ''}`
          : `d-flex align-items-sm-center justify-content-center flex-grow-1 flex-direction-column
              ${this.stretch ? 'stretched' : ''}`;
      },
      langs: () => locales,
      titleLocalized() {
        if (this.pageTitle == null || !this.pageTitle) return false;
        if (this.pageTitle.charAt(0) !== '*') {
          return this.pageTitle;
        }
        const path = this.pageTitle.slice(1);
        return this.$te(path) ? this.$t(path).capitalizeAll() : false;
      },
      userName() {
        const { user } = this;
        if (user != null && user.profile != null) return user.profile.name;
        return '';
      },
      legalPagesList() {
        return this.$t('pages.legal.pages').map(({ slug, title }) => ({
          slug,
          title,
        }));
      },
      currentBackground() {
        const {
          r, g, b, a,
        } = this.currentColorSchema.rgba;
        return `background-color: rgba(${r}, ${g}, ${b}, ${a})`;
      },
    },
    watch: {
      $route() {
        this.mobileShown = false;
        if (this.$route.name === 'login') {
          this.resetColorScheme();
        }
      },
      async asLoggedIn() {
        if (this.asLoggedIn) {
          this.logo();
        }
      },
      pageTitle() {
        this.updateTitle();
      },
      titleLocalized() {
        this.updateTitle();
      },
      sessionExpired(yes) {
        if (yes) {
          this.$refs.expiredModal.show();
        } else {
          this.$refs.expiredModal.hide();
        }
      },

    },
    mounted() {
      Storage.addListener(LANG_KEY, (locale) => {
        this.setLang(locale);
      });
      Storage.addListener(USER_KEY, (user) => {
        if (user != null && !this.loggedIn) {
          // login from other tab
          this.login({ syncUser: user });
        } else if (user == null && this.loggedIn) {
          // logout from other tab
          this.logout({ forced: true, stay: true });
        } else if (user != null && user.id !== this.user.id) {
          // something weird has happened
          window.location.reload();
        }
      });

      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        this.collapseId = collapseId;
        this.isJustShown = isJustShown;
      });
    },
    methods: {
      ...mapMutations('user', ['setLang']),
      ...mapActions('auth', ['login', 'logout']),
      // ...mapActions('typesense', ['searchRecords', 'resetSearchToEmpty']),
      logo() {
        this.resetColorScheme();
        if (this.hotelID && this.asLoggedIn) {
          this.user.hotels.forEach((t) => {
            if (t.id === this.hotelID) {
              if (t.property_group) {
                this.logoMenu = (t.property_group.logo);
                this.color_font = JSON.parse(t.property_group.style).color_font.rgba;
                this.color_schema = JSON.parse(t.property_group.style).color_schema.rgba;
              }
            }
          });
        }
      },
      resetColorScheme() {
        this.color_schema = {
          r: 74,
          g: 143,
          b: 221,
        };
        this.color_font = {
          r: 255,
          g: 255,
          b: 255,
        };
        this.logoMenu = null;
      },
      updateTitle() {
        const tl = this.titleLocalized;
        let title = 'Translation Tool';
        if (tl !== false) {
          title = `${title} - ${tl}`;
        }
        document.querySelector('head title').textContent = title;
      },
      reload() {
        this.logout({ forced: true, stay: true });
      },
      closeMobileMenu(ev) {
        if (this.mobileShown) {
          ev.preventDefault();
          ev.stopPropagation();
          ev.stopImmediatePropagation();
          this.mobileShown = false;
        }
      },
      collapseProfile() {
        if (this.isJustShown) {
          this.$root.$emit('bv::toggle::collapse', this.collapseId);
        }
      },
      // onSearch() {
      //   this.currentPage = 1;
      //   if (this.$refs.userForm && this.$refs.userForm.flags.valid) {
      //     if (this.$route.query.q === this.search) {
      //       this.hideResults = true;
      //       this.disableSearchButton = true;
      //       this.search = '';
      //       return;
      //     }
      //     const searchValue = this.search;
      //     this.search = '';
      //     this.$router.push({ name: 'searchPage', query: { q: searchValue } });
      //   }
      // },
      // handleKeyUp(event) {
      //   this.currentPage = 1;
      //   this.disableSearchButton = false;
      //   if (event.key === 'Enter') {
      //     this.onSearch();
      //   }
      //   if (this.lastSearch !== this.search) {
      //     this.hideResults = false;
      //     this.triggerSearch();
      //   }
      // },

      // triggerSearch() {
      //   clearTimeout(this.debounceTimeout);
      //   this.lastSearch = this.search;
      //   const trimmedSearch = this.search.trim();

      //   if (trimmedSearch?.length) {
      //     this.debounceTimeout = setTimeout(() => {
      //       const payload = {
      //         q: trimmedSearch,
      //         userRole: this.user.role_key,
      //         userProjects: this.user.projects,
      //         userLanguage: this.user.language,
      //       };

      //       if (this.$route.name === 'projects-all-translations') {
      //         payload.activeProject = this.activeProject;
      //         payload.activeLanguage = this.activeLanguage;
      //       }
      //       this.searchRecords(payload);
      //     }, 100);
      //   }
      // },
      // updateSearchField(result) {
      //   this.search = result.translation;
      //   setTimeout(() => {
      //     this.hideResults = true;
      //   }, 100);
      // },
      // projectTranslationsUrl(result) {
      //   const queryValue = result.translation.slice(0, 20);
      //   if (this.$route.query.q === queryValue) {
      //     setTimeout(() => {
      //       this.hideResults = true;
      //       this.search = '';
      //     }, 100);
      //     return;
      //   }

      //   const query = { q: queryValue };
      //   if (result.languageIso) {
      //     query.iso = result.languageIso;
      //   }
      //   if (this.lastQuery !== queryValue
      //     || this.$route.name !== 'projects-all-translations') {
      //     this.$router.push({
      //       name: 'projects-all-translations',
      //       params: { id: result.projectId },
      //       query,
      //     });
      //   }
      //   setTimeout(() => {
      //     this.hideResults = true;
      //   }, 100);
      //   this.search = '';
      //   this.lastQuery = queryValue;
      // },
      // handleScroll(event) {
      //   const scrollableContainer = event.target;
      //   const { scrollTop } = scrollableContainer;
      //   const containerHeight = scrollableContainer.clientHeight;
      //   const contentHeight = scrollableContainer.scrollHeight;

      //   const scrollPosition = scrollTop + containerHeight;
      //   const halfScreenHeight = containerHeight / 2;

      //   if (scrollPosition >= contentHeight - halfScreenHeight) {
      //     if (this.$route.query.q && this.currentPage * 20
      //       < this.totalKeywords && this.readyLoadMoreKeywords &&
      //  this.$route.name === 'searchPage') {
      //       this.currentPage += 1;
      //       this.$router.push({ name: 'searchPage', query: { q: this.$route.query.q, page: this.currentPage } });
      //     }
      //   }
      // },
      // handleClickOutside(event) {
      //   const { searchResultsContainer, searchInput } = this.$refs;
      //   if (
      //     searchResultsContainer
      //     && !searchResultsContainer.contains(event.target)
      //     && searchInput
      //     && searchInput.$el
      //     && !searchInput.$el.contains(event.target)
      //   ) {
      //     this.hideResults = true;
      //   }
      // },
      // handleFocus() {
      //   this.inputFocused = true;
      //   this.hideResults = false;
      // },
      // handleBlur() {
      //   this.inputFocused = false;
      // },
    },
  };
</script>

<style scoped>
/* .hide-search-results {
  display: none;
}

.results-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 400px;
  overflow-y: auto;
}

.results-list li:last-child {
  border-bottom: none;
}

.result-item {
  cursor: pointer;
  border-bottom: 1px solid rgb(216, 216, 216);
  color: #545d6c;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.result-item:hover {
  background-color: #f0f0f0;
}

.search-results-spinner {
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  z-index: 1000;
  min-width: 420px;
  max-height: 350px;
  position: absolute;
  top: 50px;
  overflow-y: auto;
}

.lessResults {
  overflow-y: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 5px;
}

.search-width {
  width: 300px;
} */
</style>
